import Vue from 'vue'
import Router from 'vue-router'
import { roles } from '@/main.config.js'
import beforeRoute from '@/router/beforeEach.js'
import i18n from '@/i18n.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/Login.vue'),
      meta: {
        noAuth: true,
        emptyLayout: true
      }
    },
    {
      path: '/registration/:token',
      name: 'registration',
      component: () => import('@/pages/Registration.vue'),
      meta: {
        noAuth: true,
        emptyLayout: true
      }
    },
    {
      path: '/',
      name: 'Home',
      component: () => import('@/pages/Home.vue'),
      meta: {
        root: true
      }
    },
    {
      path: '/courses',
      name: 'courses',
      component: () => import('@/pages/Courses.vue'),
      meta: {
        roles: [roles.doctor, roles.hospital, roles.neuro, roles.readonly],
        metaTitle: i18n.t('entity.courses')
      }
    },
    {
      path: '/courses/add',
      name: 'course-add',
      component: () => import('@/pages/CoursesAdd.vue'),
      meta: {
        roles: [roles.doctor, roles.hospital],
        metaTitle: i18n.t('router.addingCourse')
      }
    },
    {
      path: '/courses/edit/:id',
      name: 'course-edit',
      component: () => import('@/pages/CoursesEdit.vue'),
      meta: {
        roles: [roles.doctor, roles.hospital, roles.neuro, roles.readonly],
        metaTitle: i18n.t('entity.course')
      }
    },
    //Один и тот же компонент, но для разных ситуаций (когда курс добавляется и когда редактируется)
    {
      path: '/new-course-binding/:id',
      name: 'new-course-binding',
      component: () => import('@/pages/CoursesBinding.vue'),
      meta: {
        roles: [roles.doctor, roles.hospital],
        metaTitle: i18n.t('router.linkingCourse')
      }
    },
    {
      path: '/course-binding/:id',
      name: 'course-binding',
      component: () => import('@/pages/CoursesBinding.vue'),
      meta: {
        roles: [roles.doctor, roles.hospital],
        metaTitle: i18n.t('router.linkingCourse')
      }
    },
    {
      path: '/course-closing/:id',
      name: 'course-closing',
      component: () => import('@/pages/CourseClosing.vue'),
      meta: {
        roles: [roles.doctor, roles.hospital],
        metaTitle: i18n.t('router.closingCourse')
      }
    },
    {
      path: '/sessions',
      name: 'sessions',
      component: () => import('@/pages/Trainings.vue'),
      meta: {
        roles: [roles.doctor, roles.hospital, roles.neuro, roles.readonly],
        metaTitle: i18n.t('entity.sessions')
      }
    },
    {
      path: '/sessions/:id',
      name: 'session-view',
      component: () => import('@/pages/TrainingView.vue'),
      meta: {
        roles: [roles.doctor, roles.hospital, roles.neuro, roles.readonly],
        metaTitle: i18n.t('entity.session')
      }
    },
    {
      path: '/multiple-sessions',
      name: 'active-sessions-multiple',
      component: () => import('@/pages/ActiveTrainingsMultiple.vue'),
      meta: {
        roles: [roles.doctor, roles.hospital, roles.neuro, roles.readonly],
        metaTitle: 'Много сессий'
      }
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/pages/Users.vue'),
      meta: {
        roles: [roles.hospital, roles.neuro],
        metaTitle: i18n.t('entity.users')
      }
    },
    {
      path: '/users/add',
      name: 'user-add',
      component: () => import('@/pages/UserAdd.vue'),
      meta: {
        roles: [roles.hospital, roles.neuro],
        title: i18n.t('router.createUserAccount'),
        metaTitle: i18n.t('router.addingUser')
      }
    },
    {
      path: '/users/edit/:id',
      name: 'user-edit',
      component: () => import('@/pages/UserEdit.vue'),
      meta: {
        roles: [roles.hospital, roles.neuro],
        title: i18n.t('router.editingAccount'),
        metaTitle: i18n.t('router.editingUser'),
        allowHimself: true
      }
    },
    {
      path: '/admins',
      name: 'admins',
      component: () => import('@/pages/Users.vue'),
      meta: {
        roles: [roles.neuro],
        showRole: roles.neuro,
        ui: 'neuro',
        metaTitle: i18n.t('router.neurosoftAdministrators')
      }
    },
    {
      path: '/admins/add',
      name: 'admin-add',
      component: () => import('@/pages/UserAdd.vue'),
      meta: {
        roles: [roles.neuro],
        title: i18n.t('router.createAdministratorAccount'),
        addRole: roles.neuro,
        ui: 'neuro',
        metaTitle: i18n.t('router.addingNeurosoftAdministrator')
      }
    },
    {
      path: '/devicesAdmin',
      name: 'devicesAdmin',
      component: () => import('@/pages/DevicesAdmin.vue'),
      meta: {
        roles: [roles.neuro],
        metaTitle: i18n.t('entity.devices')
      }
    },
    {
      path: '/devices',
      name: 'devices',
      component: () => import('@/pages/Devices.vue'),
      meta: {
        roles: [roles.hospital, roles.neuro],
        metaTitle: i18n.t('entity.devices')
      }
    },
    {
      path: '/patients',
      name: 'patients',
      component: () => import('@/pages/Patients.vue'),
      meta: {
        roles: [roles.hospital, roles.neuro, roles.doctor, roles.readonly],
        metaTitle: i18n.t('entity.patients')
      }
    },
    {
      path: '/patients/add',
      name: 'patient-add',
      component: () => import('@/pages/PatientAdd.vue'),
      meta: {
        roles: [roles.hospital, roles.neuro, roles.doctor],
        title: i18n.t('router.creatingPatientAccount'),
        metaTitle: i18n.t('router.addingPatient')
      }
    },
    {
      path: '/patients/edit/:id',
      name: 'patient-edit',
      component: () => import('@/pages/PatientEdit.vue'),
      meta: {
        roles: [roles.doctor, roles.hospital, roles.neuro],
        title: i18n.t('router.editingPatientAccount'),
        metaTitle: i18n.t('router.editingPatient')
      }
    },
    {
      path: '/hospitals',
      name: 'hospitals',
      component: () => import('@/pages/Hospitals.vue'),
      meta: {
        roles: [roles.neuro],
        ui: 'neuro',
        metaTitle: i18n.t('src/pages/hospitals.915')
      }
    },
    {
      path: '/hospitals/add',
      name: 'hospital-add',
      component: () => import('@/pages/HospitalsAdd.vue'),
      meta: {
        roles: [roles.neuro],
        adminLayout: true,
        title: i18n.t('router.creatingMedicalInstitution'),
        ui: 'neuro',
        metaTitle: i18n.t('router.addingHospital')
      }
    },
    {
      path: '/hospitals/edit/:id',
      name: 'hospital-edit',
      component: () => import('@/pages/HospitalsEdit.vue'),
      meta: {
        roles: [roles.neuro, roles.hospital],
        adminLayout: true,
        title: i18n.t('router.editingMedicalInstitution'),
        ui: 'neuro',
        metaTitle: i18n.t('router.editingHospital')
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/pages/Settings.vue'),
      meta: {
        roles: [roles.neuro],
        ui: 'neuro',
        metaTitle: i18n.t('router.serverSettings')
      }
    },
    {
      path: '/logging',
      name: 'logging',
      component: () => import('@/pages/Logging.vue'),
      meta: {
        roles: [roles.neuro],
        ui: 'neuro',
        metaTitle: i18n.t('entity.logging')
      }
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: () => import('@/pages/Agreement.vue'),
      meta: {
        metaTitle: i18n.t('router.privacyPolicy'),
        noAuth: true,
        emptyLayout: true
      }
    },
    {
      path: '/documents',
      name: 'documents',
      component: () => import('@/pages/DocumentsPage.vue'),
      meta: {
        roles: [roles.doctor, roles.hospital, roles.neuro]
      }
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/pages/NotFound.vue'),
      meta: {
        metaTitle: i18n.t('router.pageNotFound'),
        noAuth: true,
        emptyLayout: true
      }
    },
    {
      path: '*',
      component: () => import('@/pages/NotFound.vue'),
      meta: {
        metaTitle: i18n.t('router.pageNotFound'),
        noAuth: true,
        emptyLayout: true
      }
    },
    {
      path: ':id',
      name: 'errors',
      component: () => import('@/pages/NotFound.vue'),
      meta: {
        metaTitle: i18n.t('router.pageNotFound'),
        noAuth: true,
        emptyLayout: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  beforeRoute(to, from, next)
})

export default router
